import routes from "./insightsRoutes";
import raw from "./rawClients/rawInsightsClient";
export default {
  NAME: "insightsClient",
  charts: {
    get: (orgId, chartId, fromDate, toDate) =>
      raw.get(
        `${routes.charts.one(
          orgId,
          chartId
        )}?from_date=${fromDate}&to_date=${toDate}`
      ),
  },
  projects: {
    setDates: (projectId, startDate, endDate) =>
      raw.patch(`${routes.projects.setDates(projectId)}`, {
        start_date: startDate,
        end_date: endDate,
      }),
  },
  orgInsights: {
    get: orgId => raw.get(routes.orgInsights.all(orgId)),
  },
};
